'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colorSet", "selectedColorSet", "selected", "children", "className", "hover", "active", "focus", "as", "component"];
import React, { useContext } from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { deprecatedPropWarning } from "../../logging.mjs";
import { addColorSet, textClass } from "../../styles/index.mjs";
import { ecx } from "../../utils.mjs";
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
/**
 * Use Tags to present a collection of attributes to describe a piece of content.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-tag--docs) |
 * [Encore site](https://encore.spotify.net/web/components/tags) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Tag) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-9101&t=e8dHQIUZZe5vvdNY-1)
 */

export var Tag = function Tag(_ref) {
  var colorSet = _ref.colorSet,
    selectedColorSet = _ref.selectedColorSet,
    selected = _ref.selected,
    children = _ref.children,
    className = _ref.className,
    hover = _ref.hover,
    active = _ref.active,
    focus = _ref.focus,
    as = _ref.as,
    component = _ref.component,
    props = _objectWithoutProperties(_ref, _excluded);
  if (selected) {
    deprecatedPropWarning('selected', 'Tag', 'Please use the Chip component with a selected prop instead.');
  }
  if (selectedColorSet) {
    deprecatedPropWarning('selectedColorSet', 'Tag', 'Please use the Chip component with a selectedColorSet prop instead.');
  }
  var _useContext = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext.useBrowserDefaultFocusStyle;
  var currentColorSet = selected ? selectedColorSet || 'invertedDark' : colorSet;
  var polymorphicProp = as ? as : component;
  var Element = polymorphicProp ? polymorphicProp : 'span';
  return /*#__PURE__*/React.createElement(Element, Object.assign({}, props, {
    className: ecx(['tag', 'baseline', addColorSet(currentColorSet), {
      'focus-border': focus || !useBrowserDefaultFocusStyle,
      'focus-border--focus': focus,
      'tag--hover': hover,
      'tag--active': active
    }]),
    "data-encore-id": ENCORE_DATA_IDS.Tag
  }), /*#__PURE__*/React.createElement("div", {
    className: ecx(['tag__inner', textClass('marginalBold'), addColorSet(currentColorSet), {
      'tag__inner--selected': selected,
      'tag__inner--color-set': !!colorSet
    }], className)
  }, children));
};